<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑红包设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="cashlist.length > 1 ? cashlist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回设置管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsCash'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in cashlist" :key="index">
            <div class="TTL-form-submit-box-title">设置-{{index+1}}</div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">设置名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入设置名称',type:'input',clearable:true,ischange:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.name=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">红包金额<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入红包金额',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.cash"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.cash=val.value;
                            }
                            if(val.type=='change') {
                                item.cash=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">红包数量<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入红包数量',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.nums"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.nums=val.value;
                            }
                            if(val.type=='change') {
                                item.nums=val.value;
                            }
                        }"
                    />
                </el-form-item>
                
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_CASH from '@/Interface/Es/Cash';
export default {
    components:{},
    data() {
        return {
            Browser:'editcash',
            loadingobj:'editcash',
            limit:10,  //限制添加数据条数      
            cashlist:[], //红包设置

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetCashInfo(data.param.id);
                }).catch(()=> {

                });
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetCashInfo(data.param.id);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.cashlist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个设置',type:'warning'});return false;}
            var data=[];
            for(var i in this.cashlist) data.push(this.cashlist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_CASH.SAVE_CASH({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
                this.$parent.JUMPVIEW({name:'EsCash',delname:'EditCash'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取续费设置信息 **/
        GetCashInfo(id) {
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_CASH.GET_CASH_INFO({ids:id}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.cashlist=res.data;
                console.log(res.data);
            });
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>